import { parseImportedTasks } from '../../features/tasks/utils/taskImportExport';
import { generateClientSideId } from './clientIdGenerator';

/**
 * Build task objects from imported text (preset/help content).
 * @param {string} fileId - File id to assign to tasks
 * @param {string} text - Raw text content
 * @returns {Array} Array of task objects with id, _reactKey, file_id, text, status, due_date, parent_task_id, order
 */
export function buildTasksFromText(fileId, text) {
  const parsedTasks = parseImportedTasks(text);
  const tasksToCreate = [];
  const indentStack = [];
  const orderCounters = new Map();

  parsedTasks.forEach((task, index) => {
    while (indentStack.length > 0 && indentStack[indentStack.length - 1].indentLevel >= task.indentLevel) {
      indentStack.pop();
    }

    const parentTaskId = indentStack.length > 0 ? indentStack[indentStack.length - 1].taskId : null;
    const parentKey = parentTaskId === null ? 'root' : parentTaskId;
    const order = (orderCounters.get(parentKey) || 0) + 1;
    orderCounters.set(parentKey, order);

    const id = `${fileId}-${index + 1}`;
    const builtTask = {
      id,
      _reactKey: generateClientSideId(),
      file_id: fileId,
      text: task.text || '',
      status: task.status || 'incomplete',
      due_date: task.dueDate || null,
      parent_task_id: parentTaskId,
      order,
    };

    tasksToCreate.push(builtTask);
    indentStack.push({ indentLevel: task.indentLevel, taskId: id });
  });

  return tasksToCreate;
}
